import { Markdown } from '../../../markdown/Markdown';
import { getHelpCenterLinks } from 'venn-ui-kit';
import React from 'react';

export const ComparisonHelpLink = () => (
  <Markdown
    children={`Need some help? View a [help center article](${getHelpCenterLinks().PORTFOLIO_COMPARISON_HELP_HREF}).`}
  />
);
